import WarehouseCURModule from "@/modules/WarehouseCUR";

function CreateWarehousePage() {
  return <WarehouseCURModule type="create" />;
}

export default CreateWarehousePage;
